import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Avatar from "canvas-core-react/lib/Avatar";
import TextBody from "canvas-core-react/lib/TextBody";
import Hamburger from "canvas-core-react/lib/Hamburger";
import HamburgerLink from "canvas-core-react/lib/HamburgerLink";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import IconChevronDown from "canvas-core-react/lib/IconChevronDown";
import IconUsername from "canvas-core-react/lib/IconUsername";
import IconExit from "canvas-core-react/lib/IconExit";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";
import Modal from "../../utils/customModal";
import { getEnvironment } from "../../../Redux/reducer/env";
import { logout } from "../../../Redux/actions/sessionActions";
import { getSessionInfo } from "../../../Redux/reducer/session";
import sessionService from "../../../Redux/services/sessionService";
import { getAllowedCompanies } from "../../../Redux/reducer/cifCross";
import {
  changeCompanyToken,
  getPermitedCompanies,
} from "../../../Redux/actions/cifCrossActions";
import {
  loadingHtml,
  errorContainer,
  getLogoutURL,
} from "../../utils/functions";

import CustomSelect from "../custom-components/customSelect";

const Header = (props) => {
  var _isMounted = false;

  const { t, i18n } = useTranslation();
  const [companyMenu, setCompanyMenu] = useState(false);
  const [userMenu, setUserMenu] = useState(false);

  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });

  //StateProps
  const dispatch = useDispatch();
  const session = useSelector((state) => getSessionInfo(state));
  const env = useSelector((state) => getEnvironment(state));
  const allowedCompanies = useSelector((state) => getAllowedCompanies(state));
  const { pathname } = useLocation();

  const handleChangeLanguage = (e) => {
    sessionService.saveLanguage(e.target.value);
    location.reload();
  };

  useEffect(() => {
    _isMounted = true;

    if (session.userType === "CSA" && allowedCompanies === null) {
      dispatch(getPermitedCompanies());
    }

    return () => {
      _isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (
      !pathname.includes("/bills") &&
      !pathname.includes("/providers") &&
      session.allCompanies === true
    ) {
      changeCompany(null, session.mainInstitution);
    }
  }, [pathname]);

  const doLogout = () => {
    const customModal = { ...modal };

    setUserMenu(false);

    customModal.show = true;
    customModal.content = loadingHtml(`${t("header.loadingModal")}`);
    setModal(customModal);

    const country = sessionService.getUser().countryCode;

    return dispatch(logout())
      .then(() => {
        // Se cerró sesión correctamente
        redirect(env, country);
      })
      .catch(() => {
        redirect(env, country);

        customModal.show = true;
        customModal.content = errorContainer(
          `${t("header.logout.errorTitle")}`,
          `${t("header.logout.errorDescription")}`
        );
        customModal.onClose = () => {
          this.setState({
            modal: { show: false, content: null, onClose: undefined },
          });
        };
        if (_isMounted) {
          setModal(customModal);
        }
      });
  };

  const redirect = (env, country) => {
    const userType = session.userType;
    if (country === "PA" && userType === "CSA") {
      var url = getLogoutURL(env);
      if (url !== "") {
        window.location = url;
      }
    }
  };

  const changeCompany = (e, cif) => {
    if (e !== null) {
      e.preventDefault();
    }

    const customModal = { ...modal };

    customModal.show = true;
    customModal.content = loadingHtml(`Cargando datos de empresa...`);
    setModal(customModal);

    let nwcif = cif === null ? session.institutionId : cif;
    let all = cif === null ? true : false;

    return dispatch(changeCompanyToken(nwcif, all))
      .then(() => window.location.reload())
      .catch((err) => console.error(err));
  };

  const getLastSession = () => {
    var lastConection = new Date(session.lastSession);
    var timezonediff = lastConection.getTimezoneOffset() * 60000;
    lastConection.setTime(lastConection.getTime() - timezonediff);

    return lastConection;
  };

  return (
    <React.Fragment>
      <header className={props.wrapperClass}>
        <div className="reverse">
          <p>{t("appName")}</p>
        </div>
        <div className="separator"></div>
        <div className="comapny-name">
          <p>
            {session.allCompanies
              ? t("general.labels.all")
              : session.institutionName}
          </p>
        </div>
        {allowedCompanies !== null && (
          <Hamburger
            className={`menu-drop`}
            Icon={IconChevronDown}
            menuButtonLabel="Menu"
            closedMenuButtonLabel="close menu"
            openMenuLabel="menu open"
            isMenuOpen={companyMenu}
            setIsMenuOpen={setCompanyMenu}
          >
            {allowedCompanies.map(
              ({ child_name, child_customer_id, parent_customer_id }, key) => (
                <HamburgerLink
                  key={`lnk-${key}`}
                  href={``}
                  onClick={(e) =>
                    changeCompany(e, child_customer_id || parent_customer_id)
                  }
                >
                  <TextBody component={`p`}>{child_name}</TextBody>
                </HamburgerLink>
              )
            )}
            {/*         {(pathname.includes("/bills") ||
              pathname.includes("/providers")) && (
              <HamburgerLink
                key={`lnk-all`}
                href={``}
                onClick={(e) => changeCompany(e, null)}
              >
                <TextBody component={`p`}>{t("general.labels.all")}</TextBody>
              </HamburgerLink>
            )} */}
          </Hamburger>
        )}
        <div className="user row">
          {session.lastSession != null && session.lastSession != undefined && (
            <p className="lastConection">
              {`${t(
                "header.lastconectionlbl"
              )}: ${getLastSession().toLocaleString("es-US")}`}
            </p>
          )}
          <div className="user-info">
            <Avatar
              id={`user-avatar`}
              text={`${session.firstName.substr(0, 1)}${session.lastName.substr(
                0,
                1
              )}`}
              ariaLabel={session.institutionName}
              size={48}
            />
            <ActionMenuList
              id="login-menu"
              dialogPosition="bottom-right"
              iconType="vertical-small"
              bottomSheet={{
                heading: "Actions",
                secondaryAction: {
                  onClick: () => {},
                  label: "Cancel",
                },
              }}
              isMenuOpen={userMenu}
              setIsMenuOpen={setUserMenu}
              className="fix-menu-position"
            >
              <div className="px-4 mb-3">
                <CustomSelect
                  onChange={handleChangeLanguage}
                  value={i18n.language}
                  className="select-language-fix"
                  items={languages.map((value) => ({
                    value,
                    label: t(`languages.${value}`),
                  }))}
                />
              </div>
              <ActionMenuListItem
                icon={() => <IconUsername className="TextButton__icon--left" />}
              >
                {`${session.firstName} ${session.lastName}`}
              </ActionMenuListItem>

              <ActionMenuListItem
                icon={() => <IconExit className="TextButton__icon--left" />}
                onClick={doLogout}
              >
                {t("header.logoutLbl")}
              </ActionMenuListItem>
            </ActionMenuList>
            <div className="user-info-data"></div>
          </div>
        </div>
      </header>
      <Modal show={modal.show} handleClose={modal.onClose}>
        {modal.content}
      </Modal>
    </React.Fragment>
  );
};

export default Header;

const languages = ["es", "en"];
